var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44024 1.06548C7.26045 -0.355162 9.31097 -0.355159 10.1312 1.06548L16.2827 11.7203C17.1029 13.1409 16.0777 14.9167 14.4373 14.9167H2.13414C0.493725 14.9167 -0.531534 13.1409 0.288674 11.7203L6.44024 1.06548ZM8.90086 1.7758C8.62746 1.30226 7.94395 1.30226 7.67055 1.7758L1.51899 12.4306C1.24558 12.9042 1.58734 13.4961 2.13414 13.4961H14.4373C14.9841 13.4961 15.3258 12.9042 15.0524 12.4306L8.90086 1.7758Z",
    fill: "#D83232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.28574 4.11986C8.7565 4.11986 9.13812 4.50149 9.13812 4.97225L9.13812 9.23417C9.13812 9.70493 8.7565 10.0866 8.28574 10.0866C7.81498 10.0866 7.43335 9.70493 7.43335 9.23417L7.43335 4.97225C7.43335 4.50149 7.81498 4.11986 8.28574 4.11986Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13812 11.5072C9.13812 11.978 8.75649 12.3596 8.28574 12.3596C7.81498 12.3596 7.43335 11.978 7.43335 11.5072C7.43335 11.0364 7.81498 10.6548 8.28574 10.6548C8.75649 10.6548 9.13812 11.0364 9.13812 11.5072Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d3d27533f32357ae31002c2ec3132b15.svg";
export { ForwardRef as ReactComponent };